export const en = {
  common: {
    reserve: "Reserve a pool now",
    popular: "Popular",
    selection: "Johnny's Selection",
    ongoing: "Ongoing",
    upcoming: "Upcoming",
    expired: "Expired",
    learnMore: "Learn More",
    viewMenu: "View Full Menu",
    viewAllEvents: "View All Events",
    bookTable: "Book a Table",
    rights: "All rights reserved.",
    tagline: "The best hangout spot in Pierrefonds.",
    skipWait: "Skip the wait and secure your spot for a great night out."
  },
  nav: {
    home: "Home",
    menu: "Menu",
    poolEvents: "Pool & Events",
    gallery: "Gallery",
    about: "About",
    contact: "Contact"
  },
  home: {
    hero: {
      welcome: "Welcome to",
      subtitle: "The ultimate hangout spot in Pierrefonds for premium pool, cold drinks, and great food.",
      explore: "Explore Menu"
    },
    about: {
      since: "Since 1998",
      title: "Our Story & Passion",
      text: "Johnny's Bar Billard isn't just a place to play pool; it's a Pierrefonds landmark. For over two decades, we've provided a vibrant space for the community to gather, unwind, and enjoy top-tier hospitality."
    },
    menu: {
      title: "Skeptical? Taste It.",
      subtitle: "Explore our curated selection of mouth-watering bar bites and refreshing draft beers."
    },
    events: {
      tag: "What's Happening",
      title: "Upcoming Events"
    },
    cta: {
      title: "Ready for a game?",
      text: "Join us tonight for the best pool experience in Pierrefonds. Tables are available on a first-come, first-served basis or via reservation."
    }
  },
  about: {
    welcome: "Welcome to Johnny's Bar Billard, the premier destination for billiards, great food, and good times in Pierrefonds, Montreal.",
    title: "About Us",
    missionTitle: "Our Mission",
    missionText: "To provide a vibrant, welcoming space where the community can gather, unwind, and enjoy top-tier entertainment and hospitality.",
    p1: "Established with a passion for the game and a love for our local community, Johnny's has grown to become more than just a pool hall. We are a neighborhood staple where friends meet, rivalries are settled on the table, and memories are made over cold drinks.",
    p2: "Our facility boasts meticulously maintained professional tables, ensuring that whether you are a casual player or a seasoned league competitor, your experience is nothing short of excellent. But we know that a great night out requires more than just a good break.",
    p3: "That is why we have crafted a menu full of comforting bar classics and stocked our bar with a wide selection of draft beers and spirits. Our friendly staff is dedicated to making sure your glass is never empty and your time here is always enjoyable.",
    footerBox: "Proudly Serving Pierrefonds",
    footerText: "We are proud to be a part of the vibrant Montreal community. Come visit us and see why we are the best hangout spot in town."
  },
  poolEvents: {
    title: "Events & Tournaments",
    subtitle: "Join the community. From professional leagues to casual weekend tournaments.",
    hostTitle: "Host Your Own Event",
    hostText: "Planning a birthday party, corporate hangout, or a private tournament? Johnny's offers table reservations and catering packages specifically for groups.",
    features: [
      "Reserved Professional Tables",
      "Dedicated Service Staff",
      "Custom Food & Drink Menus",
      "Private Sound System Options"
    ],
    startsAt: "Starts at 7:00 PM"
  },
  contact: {
    title: "Find Us",
    subtitle: "Ready to play? We are located in the heart of Pierrefonds. Drop by or reserve your table now.",
    location: "Location",
    hours: "Opening Hours",
    cta: "Want to secure a table for tonight?"
  },
  menu: {
    title: "Our Menu",
    subtitle: "Fuel up for your game with our delicious comfort food and refreshing drinks.",
    ctaTitle: "Hungry for a game?",
    ctaText: "Grab a table and order right from your spot. We serve until late!"
  }
};